export default {
  slots: {
    base: 'w-full cursor-pointer hover:shadow-sm transition-shadow shadow-(color:--ui-input-shadow-light) dark:shadow-(color:--ui-input-shadow-dark) duration-300 hover:ring-(--ui-input-ring-accented-light) dark:hover:ring-(--ui-input-ring-accented-dark)',
    item: 'cursor-pointer w-full !py-1',
    content: 'z-50 max-h-80',
  },
}